import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

export const RESULTS_PER_PAGE = 10;

interface UseAllOrdersParams {
  seedSlug?: string;
  page?: number;
  pageSize?: number;
}

export const useAllOrders = ({
  seedSlug,
  page = 1,
  pageSize = RESULTS_PER_PAGE,
}: UseAllOrdersParams) => {
  const fetch = useFetch();

  const queryFn = () => {
    if (!seedSlug) {
      return { data: undefined, isLoading: false, error: null };
    }

    const params = new URLSearchParams();
    params.append("page_size", pageSize.toString());
    if (page) {
      params.append("page", page.toString());
    }

    const queryString = params.toString();
    const url = `${API}/api/feira_online/seeds/${seedSlug}/orders${queryString ? `?${queryString}` : ""}`;

    return fetch(url);
  };

  return useQuery({
    queryKey: ["all-orders", seedSlug, page, pageSize],
    queryFn,
    staleTime: 1000 * 60 * 5, // 5 minutos
    keepPreviousData: true, // Para paginação suave
    refetchOnWindowFocus: false, // Evitar refetch desnecessário
    retry: (failureCount, error: any) => {
      // Retry em caso de erro de rede, mas não para 401/403
      if (error?.status === 401 || error?.status === 403) {
        return false;
      }
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    enabled: seedSlug !== undefined,
  });
};

export default useAllOrders;
